<script lang="ts">
  import Opengraph from "$components/partials/opengraph.svelte";
  import PageTitle from "$components/partials/page-title.svelte";
  import Advertisement from "$components/ui/advertisement.svelte";
  import ArticleCard from "$components/cards/article-card.svelte";
  import ArticlesGrid from "$components/sections/articles-grid.svelte";
  import SocialShareBar from "$components/ui/social-share-bar.svelte";
  import VideoCard from "$components/cards/video-card.svelte";
  import HtmlContent from "$components/ui/html-content.svelte";
  import Chevron from "$components/icons/iconsax/chevron.svelte";

  export let data;

  $: src = `https://www.youtube.com/embed/${data.video.videoId}?rel=0&color=white&wmode=opaque&autoplay=1`;
</script>

<PageTitle description={data.video.summary} title={data.video.title} />
<Opengraph node={data.video} />

<div class="video">
  <div layout="main-content">
    <iframe
      {src}
      title={data.video.title}
      frameborder="0"
      allowfullscreen
      allow="autoplay; fullscreen"
    >
      <a title={data.video.title} href={src}>
        {data.video.title}
      </a>
    </iframe>
  </div>
</div>

<div layout="main-content" class="content">
  <aside>
    <div class="header">
      <span typography="overline">{data.videoSeries.title.toUpperCase()}</span>
      <h1 typography="title1">{data.video.title}</h1>

      <SocialShareBar type="videos" item={data.video} />
    </div>

    {#if data.video.content}
      <div class="description" typography="body-small">
        <HtmlContent content={data.video.content} />
      </div>
    {/if}

    {#if data.moreVideos.length}
      <div class="more">
        <h2 typography="title2">Mer från {data.videoSeries.title}</h2>

        <ul class="videos">
          {#each data.moreVideos as videoInSeries}
            <li>
              <VideoCard
                imageHeight="narrow"
                video={videoInSeries}
                videoSeriesList={[data.videoSeries]}
                orientation="horizontal"
                mobileOrientation="vertical"
                showSummary
              />
            </li>
          {/each}
        </ul>
      </div>
    {/if}

    <a title="Upptäck fler filmklipp" href="/tv" class="discover-link">
      Upptäck fler filmklipp
      <Chevron color="var(--text-light-strong)" size={20} direction="right" />
    </a>
  </aside>

  <aside>
    <Advertisement type="sidebar" id="ad-sidebar-1" />

    {#if data.relatedArticles.length}
      <h3 typography="title3">Relaterade artiklar</h3>

      <ul class="trending-articles">
        {#each data.relatedArticles as article}
          <li>
            <ArticleCard {article} size="x-small" orientation="horizontal" />
          </li>
        {/each}
      </ul>
    {/if}
  </aside>
</div>

<ArticlesGrid
  title="Mer från RES"
  titleCentered
  bgColor="var(--background-light-soft)"
  articles={data.moreFromResArticles}
/>

<style>
  .video {
    background-color: rgb(36 33 30);
  }

  .content {
    display: grid;
    grid-template-columns: 1fr 400px;
    gap: 32px;
  }

  aside {
    display: flex;
    flex-flow: column;
    gap: 32px;
    padding: 32px 0;
  }

  .header {
    display: flex;
    flex-flow: column;
    padding-bottom: 32px;
    border-bottom: 1px solid var(--primary100);
  }

  .header > [typography="overline"] {
    color: var(--interactive-01);
    font-weight: 600;
  }

  .header > [typography="title1"] {
    margin-bottom: 24px;
  }

  .description {
    padding-bottom: 32px;
    border-bottom: 1px solid var(--primary100);
  }

  .more {
    display: flex;
    flex-flow: column;
    gap: 24px;
  }

  .videos {
    display: flex;
    flex-flow: column;
    gap: 16px;
  }

  .discover-link {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    color: var(--text-light-strong);
    font-weight: var(--font-weight-semibold);
    text-decoration: none;
    border: 1px solid var(--secondary300);
    border-radius: 4px;
  }

  .trending-articles {
    display: flex;
    flex-flow: column;
    gap: 16px;
  }

  iframe {
    top: 0;
    left: 0;
    width: 100%;
    border: none;
    aspect-ratio: 16 / 9;
  }

  @media screen and (width < 1148px) {
    .video > div {
      padding: 0;
    }
  }

  @media screen and (width < 1056px) {
    .content {
      grid-template-columns: 1fr;
    }
  }
</style>
